import type { Debt, StrategyName } from '@/types'

type DebtWithEffectiveAPR = Debt & { _effectiveAPR: number }

export function sortByStrategy(
  debts: DebtWithEffectiveAPR[],
  strategy: StrategyName
): DebtWithEffectiveAPR[] {
  const active = debts.filter((d) => d.balance > 0)
  switch (strategy) {
    case 'avalanche':
      return [...active].sort((a, b) => b._effectiveAPR - a._effectiveAPR)
    case 'snowball':
      return [...active].sort((a, b) => a.balance - b.balance)
    case 'hybrid':
      return [...active].sort((a, b) => b._effectiveAPR * b.balance - a._effectiveAPR * a.balance)
    case 'minimum_only':
      return [...active].sort((a, b) => b._effectiveAPR - a._effectiveAPR)
  }
}

export { type DebtWithEffectiveAPR }
